import { QuestionProps } from "../Question";

const dropdownOptions = [
    { title: "50", value: "50" },
    { title: "50-100", value: "50-100" },
    { title: "100-150", value: "100-150" },
    { title: "150-200", value: "150-200" },
    { title: "200-300", value: "200-300" },
    { title: "300-400", value: "300-400" },
    { title: "400-500", value: "400-500" },
    { title: "500+", value: "500+" }
];

export const LeadQuizFlowQuestions: QuestionProps[] = [
    {
        index: "wedding_vibe",
        question: "What’s the vibe of your dream wedding?",
        subtitle: "Choose as many as you like",
        answer: "",
        type: "multiSelect",
        options: [
            { title: "Whimsical & Fairytale-like ✨", value: "Whimsical & Fairytale-like", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98442_14e7637731.webp" },
            { title: "Classy & Elegant 🕊️", value: "Classy & Elegant", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98441_690cb6e9c6.webp" },
            { title: "Luxurious & Glamorous 💎", value: "Luxurious & Glamorous", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98443_7d41d17c81.webp" },
            { title: "Fun & Quirky 🌈", value: "Fun & Quirky", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98440_15ee8badcd.webp" }
        ],
        logic: [{ nextIndex: "is_venue_decided" }]
    },
    {
        index: "is_venue_decided",
        question: "How’s the hunt for the venue going?",
        subtitle: "Choose one",
        answer: "",
        type: "radio",
        options: [
            { title: "Yes, booked already ✅", value: "yes" },
            { title: "Still exploring 👀", value: "still_exploring" },
            { title: "No, haven't explored ❌", value: "no" }
        ],
        logic: [
            { value: "yes", nextIndex: "venue_name" },
            { value: "still_exploring", nextIndex: "no_of_days" },
            { value: "no", nextIndex: "no_of_days" }
        ]
    },
    {
        index: "venue_name",
        question: "🥳 🎉 🥳 Congratulations! Please share the booked venue so we can together work on amazing wedding decor ideas",
        subtitle: "Choose one",
        answer: "",
        options: [],
        type: "singleSelect",
        enableSearch: true,
        logic: [{ nextIndex: "no_of_guests" }]
    },
    {
        index: "no_of_days",
        question: "Okay, how many days will your wedding celebrations last?️",
        subtitle: "Choose one",
        answer: "",
        type: "singleSelect",
        options: [
            { title: "1 day", value: "1" },
            { title: "2 days", value: "2" },
            { title: "3 days", value: "3" },
            { title: "More than 3 days", value: "more_than_3" }
        ],
        logic: [{ nextIndex: "no_of_guests" }]
    },
    {
        index: "no_of_guests",
        question: "Select the guest count for your wedding ceremonies",
        subtitle: "Choose as many as applicable",
        answer: Array.from({ length: 1 }, () => Array(8).fill('')), // Initialize answer as a 2D array
        type: "multiQuestion",
        subQuestions: [
            { question: "🤲 Mehendi", type: "dropdownSingleSelect", options: dropdownOptions },
            { question: "💍 Engagement", type: "dropdownSingleSelect", options: dropdownOptions },
            { question: "🍸 Cocktail Party", type: "dropdownSingleSelect", options: dropdownOptions },
            { question: "💃 Sangeet / Musical Night", type: "dropdownSingleSelect", options: dropdownOptions },
            { question: "🌼 Haldi", type: "dropdownSingleSelect", options: dropdownOptions },
            { question: "👰 Wedding / Muhurtham", type: "dropdownSingleSelect", options: dropdownOptions },
            { question: "🎊 Reception", type: "dropdownSingleSelect", options: dropdownOptions },
            { question: "🎺 Others", type: "textField" }
        ],
        logic: [
            { value: "yes", nextIndex: "decor_type", requiredAnswerIndex: "is_venue_decided" },
            { value: "still_exploring", nextIndex: "venue_types", requiredAnswerIndex: "is_venue_decided" },
            { value: "no", nextIndex: "venue_types", requiredAnswerIndex: "is_venue_decided" }
        ]
    },
    {
        index: "decor_type",
        question: "Which kind of floral decor do you like?",
        subtitle: "Choose as many as you like",
        answer: "",
        type: "multiSelect",
        options: [
            { title: "Maximalist & Multicolour", value: "Maximalist & Multicolour", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_Image_99488_4a69b99fc2.webp" },
            { title: "Fragrant & Immersive", value: "Fragrant & Immersive", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_99489_a826ad2e30.webp" },
            { title: "Traditional with a Twist", value: "Traditional with a Twist", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_99490_59044d1471.webp" },
            { title: "Elegant & Timeless", value: "Elegant & Timeless", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_99491_e2ac1f9bed.webp" }
        ],
        logic: [{ nextIndex: "decor_detail" }]
    },
    {
        index: "decor_detail",
        question: "Which wedding detail are you drawn to?",
        subtitle: "Choose as many as you like",
        answer: "",
        type: "multiSelect",
        options: [
            { title: "Welcome baskets", value: "Welcome baskets", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_99495_d2c7739b45.webp" },
            { title: "Dessert carts", value: "Dessert carts", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_99493_c21bb59275.webp" },
            { title: "Petal cones & folding fans", value: "Petal cones & folding fans", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_Image_ace7315c51.webp" },
            { title: "Customized photo frames", value: "Customized photo frames", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_99492_6782640037.webp" }
        ],
        logic: [{ nextIndex: "language" }]
    },
    {
        index: "venue_types",
        question: "Which type of venue feels right for your big day?",
        subtitle: "We’ll find the perfect place together!",
        answer: "",
        type: "singleSelect",
        options: [
            { title: "Banquet/Convention Hall", value: "banquet_hall_kalyana_mandapa", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98445_33ebd20f65.webp" },
            { title: "Standalone Wedding Venues", value: "wedding_venue", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98444_57759d5156.webp" },
            { title: "Hotels/Resorts", value: "hotel_resort", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_Image_98446_2fd148e059.webp" }
        ],
        logic: [
            { value: "banquet_hall_kalyana_mandapa", nextIndex: "accommodation" },
            { value: "wedding_venue", nextIndex: "package_type" },
            { value: "hotel_resort", nextIndex: "hotel_types" }
        ]
    },
    {
        index: "package_type",
        question: "What kind of standalone wedding venue?",
        subtitle: "Choose one",
        answer: "",
        type: "radio",
        options: [
            {
                title: "Value",
                value: "Value",
                imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_Image_98454_5cbe1f11be.webp",
                subtitle: "Cozy venues for intimate celebrations",
                features: ["✔️ Simple elegance", "✔️ Essential amenities", "✔️ Rooms for changing"],
                priceRange: "₹1 lakh - ₹3 lakhs*"
            },
            {
                title: "Delight",
                value: "Delight",
                imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98453_2f0f73628f.webp",
                subtitle: "Stylish and versatile spaces",
                features: ["✔️ Indoor-outdoor crowd flow", "✔️ Elegant lighting & furniture", "✔️ Rooms for accommodation"],
                priceRange: "₹3 lakhs - ₹5 lakhs*"
            },
            {
                title: "Premium",
                value: "Premium",
                imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98451_a44ebf43b9.webp",
                subtitle: "Exclusive venues with a curated vibe",
                features: ["✔️ Themed-venues", "✔️ Instagram-worthy spaces", "✔️ Suites for couple & guests"],
                priceRange: "₹5 lakhs - ₹7 lakhs*"
            },
            {
                title: "Luxe",
                value: "Luxe",
                imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98452_f0ab08a2ff.webp",
                subtitle: "Luxury venues for grand celebrations",
                features: ["✔️ Bespoke architecture", "✔️ Tailored, high-end hospitality", "✔️ Elite amenities, unique experiences"],
                priceRange: "₹7 lakhs and above*"
            }
        ],
        logic: [{ nextIndex: "accommodation" }],
        info: [
            [{ title: "Value", value: "₹1 lakh - ₹3 lakhs*" }], 
            [{ title: "Delight", value: "₹3 lakhs - ₹5 lakhs*" }], 
            [{ title: "Premium", value: "₹5 lakhs - ₹7 lakhs*" }], 
            [{ title: "Luxe", value: "₹7 lakhs and above*" }]
        ]
    },
    {
        index: "accommodation",
        question: "Do you need accommodation for your guests?",
        subtitle: "Choose one",
        type: "singleSelect",
        answer: "",
        options: [
            { title: "Yes  👍", value: "Yes" },
            { title: "No  ❌", value: "No" }
        ],
        logic: [
            { value: "Yes", nextIndex: "no_of_rooms" },
            { value: "No", nextIndex: "area" }
        ]
    },
    {
        index: "no_of_rooms",
        question: "How many rooms?",
        subtitle: "Choose one",
        answer: "",
        type: "singleSelect",
        options: [
            { title: "1-5 Rooms", value: "1-5 Rooms" },
            { title: "5-10 Rooms", value: "5-10 Rooms" },
            { title: "10-20 Rooms", value: "10-20 Rooms" },
            { title: "20-30 Rooms", value: "20-30 Rooms" },
            { title: "30+ Rooms", value: "30+ Rooms" }
        ],
        logic: [{ nextIndex: "area" }]
    },
    {
        index: "area",
        question: "Any preferred part of the city for your venue?",
        subtitle: "Choose one",
        type: "singleSelect",
        answer: "",
        options: [
            { title: "North", value: "North" },
            { title: "South", value: "South" },
            { title: "East", value: "East" },
            { title: "West", value: "West" },
            { title: "Central", value: "Central" },
            { title: "Flexible", value: "Flexible" }
        ],
        logic: [{ nextIndex: "language" }]
    },
    {
        index: "hotel_types",
        question: "What type of hotel/resort?",
        subtitle: "choose one",
        answer: "",
        type: "singleSelect",
        options: [
            { title: "3 Star", value: "3 Star", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98450_6606195948.webp" },
            { title: "4 Star", value: "4 Star", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98449_dccf31619c.webp" },
            { title: "5 Star", value: "5 Star", imgSrc: "https://meragi-cms.s3.ap-south-1.amazonaws.com/Enhance_98448_e07ac0964b.webp" }
        ],
        logic: [{ nextIndex: "accommodation" }]
    },
    {
        index: "language",
        question: "What’s your preferred language for communication?",
        type: "multiSelect",
        answer: "",
        options: [
            { title: "English", value: "English" },
            { title: "ಕನ್ನಡ (Kannada)", value: "Kannada" },
            { title: "हिंदी (Hindi)", value: "Hindi" },
            { title: "తెలుగు (Telugu)", value: "Telugu" },
            { title: "தமிழ் (Tamil)", value: "Tamil" },
            { title: "বাংলা (Bengali)", value: "Bengali" }
        ],
        logic: [{ nextIndex: "thank_you" }]
    }
];